import { createSagaActionTypes } from '../../../utils/actionFactory';

export const ADD_NEW_PERMISSION = 'ADD_NEW_PERMISSION';

export const actions = createSagaActionTypes('ADD_PERMISSION', [
  ADD_NEW_PERMISSION
]);
